import { React } from "react";
import { Routes, Route } from "react-router-dom";

import MainLayout from "layouts/MainLayout";

import Landing from "components/pages/landing/Landing";
import Services from "components/pages/landing/Services";
import FAQ2 from "components/pages/landing/Faq";
import AboutUs from "components/pages/landing/AboutUs";
import Manuals from "components/pages/landing/Manuals";
import Contact from "components/pages/landing/Contact";
import Privacypolicy from "components/pages/landing/Privacypolicy";

import FormViewRenderer from "components/forms/FormViewRenderer";
import ServiceExecutorWorfklow from "components/workflow/ServiceExecutorWorkflow";
import ResetPassword from "../ResetPassword";

import CreateAccount from "CreateAccount";
import EmailVerification from "EmailVerification";
import AddFacilities from "components/pages/landing/AddFacilities";
import Emanifest from "components/pages/landing/Emanifest";
import EmanifestPreview from "components/emanifest/EmanifestPreview";

export function LandingRoutes() {
	return (
		<Routes>
			<Route path="/" element={<Landing />} />
			<Route element={<MainLayout />}>
				<Route path="landing" element={<Landing />} />
				<Route path="services" element={<Services />} />
				<Route path="faq" element={<FAQ2 />} />
				<Route path="aboutus" element={<AboutUs />} />
				<Route path="manuals" element={<Manuals />} />
				<Route path="contact" element={<Contact />} />
				<Route path="privacypolicy" element={<Privacypolicy />} />
				<Route path="facilities" element={<AddFacilities />} />
				<Route path="emanifest" element={<Emanifest />} />
			</Route>
		</Routes>
	);
}

export function SpecialPublicIslands() {
	return (
		<Routes>
			<Route path="EmanifestPreview/:id" element={<EmanifestPreview />} />

			<Route element={<MainLayout />}>
				<Route path="form_view_renderer" element={<FormViewRenderer />} />
				<Route path="service_executor_workflow" element={<ServiceExecutorWorfklow />} />
				<Route path="reset-password" element={<ResetPassword />} />
			</Route>
		</Routes>
	);
}

export function CreateAccountIsland() {
	return (
		<>
			<CreateAccount />
			<SpecialPublicIslands />
		</>
	);
}

export function EmailVerificationIsland() {
	return (
		<>
			<EmailVerification />
			<SpecialPublicIslands />
		</>
	);
}
